import "./profile.css";
import { useState,useContext,useEffect } from 'react';
import {useNavigate,Link} from 'react-router-dom';
import CustomModal from '../../utilities/modals';
import {uscall} from '../../../us';
import AppContext from '../../../AppContext';
import UserContext from '../../../UserContext';
import { useAuth } from 'react-oidc-context';

const DeleteUser = () => {
	const navigate=useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('deleteUser');
    const auth = useAuth();
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);
    useEffect(() => {
      if(auth.isAuthenticated);
      else 
        navigate('/login/?redirect='+encodeURIComponent(document.location.href));
    },[auth,navigate]);

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const requestUserRemoval=async()=>{
        const r=await uscall(appcontext,auth,'aaa','user','request_removal',null,{uuid:usercontext.user.uuid});
        handleShowModal('deleteUser');
    };

    const handleSubmitModal1 = () => {
        handleCloseModal();
        // da gestire il redirect alla home page (quale sarebbe la home page?)
	//navigate('/');
	doLogout();
    };

    const modalContent = {
        deleteUser: {
            icon: `${process.env.PUBLIC_URL}/danger.svg`,
            title: 'Cancellazione utente',
            bodyContent: 'Ci dispiace, ma speriamo di rivederti presto!',
            bodySubtitle: 'Cancellazione utente confermata',
        },
    };
    const doLogout = async function () {
	//await fetch(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout',{credentials:'include'});
	//window.open(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout','_blank');
	auth.removeUser();
        auth.signoutRedirect();
	localStorage.clear();
	navigate('/api/session/logout/?redirect_uri='+encodeURIComponent(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout'));
        //navigate('/login/?redirect=' + encodeURIComponent(document.location.href));
    }

    const handleCloseButtonClick = () => {
        handleCloseModal();
	doLogout();
    };

	const goBack=()=>{
		navigate(-1);
	}

    return (
        <div className="account-container">
            <div className="account-top">
                <div className="row h-100 align-items-center">
                    <div className="col-1 prev-page">
			<Link to='/'>
                        <img src={`${process.env.PUBLIC_URL}/page-back.svg`} alt="Torna indietro" />
			</Link>
                    </div>
                    <div className="col-10 text-center">
                        <h1>Cancellazione account</h1>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
            <div className="account-body">
                <form>

                    <div className="row">
                        <div className="col-12">
                    <div className="d-flex align-items-center">
                        <img src={`${process.env.PUBLIC_URL}/danger.svg`} alt="Attenzione" />
                        <h2 className="mb-0">Attenzione</h2>
                    </div>
                            <p>
				
                                Questa operazione è irreversibile e comporta le seguenti conseguenze:
                            </p>
                            <ul>
                                <li><b>Perdita di accesso ai contenuti:</b> perderai l'accesso a tutti i prodotti e servizi acquistati e associati al tuo profilo (es. corsi di formazione, e-book, materiali scaricabili). Non sarà possibile recuperarli o accedere nuovamente in futuro.</li>
                                <li><b>Cancellazione dei dati:</b> tutti i tuoi dati personali presenti nel nostro sistema verranno cancellati in conformità con la normativa sulla protezione dei dati.</li>
                            </ul>
                            <p>
                            </p>
                            <p>
				<b>Tempistiche:</b> la tua richiesta sarà presa in carico e processata manualmente. L'effettiva cancellazione del tuo account avverrà entro 48 ore, giorni festivi esclusi.<br />
				Riceverai una email di conferma ad operazione completata.
                            </p>
                            <p>
				<b>Sei sicuro di voler procedere con la cancellazione definitiva del tuo account?</b>
                            </p>
                        </div>
                    </div>
                    <div className="row buttons-container">
                        <div className="col-6">
                            <input className="gradient-button" type="reset" value="Annulla" onClick={goBack} />
                        </div>
                        <div className="col-6">
                            <input className="gradient-button reset-button" type="button" value="Conferma" onClick={() => requestUserRemoval()} />
                        </div>
                    </div>
                </form>
            </div>

            {/* Modali */}
            <CustomModal
                modalType={modalType}
                showModal={showModal}
                handleClose={handleCloseButtonClick}
                handleSubmit={handleSubmitModal1}
                icon={modalContent[modalType].icon}
                title={modalContent[modalType].title}
                bodyContent={modalContent[modalType].bodyContent}
                bodySubtitle={modalContent[modalType].bodySubtitle}
                closeButtonText="Chiudi"
                closeButtonAction={handleCloseButtonClick}
            />

        </div>
    );
}

export default DeleteUser;
